import { Button, Form } from 'semantic-ui-react';

/**
 * SO# Search の Section（入力 + Search + View/Change selection + エラー表示）
 * @param {{
 *   orderNumber: string,
 *   orderSearchLoading: boolean,
 *   orderSearchResult: Object[],
 *   orderSearchError: string,
 *   orderNumberSearchSectionRef: import('react').RefObject<HTMLElement>,
 *   validationErrors: Object,
 *   onFormChange: (evn: object, data: object) => void,
 *   onSearchClick: () => void,
 *   onOrderSearchShowModalClick: () => void,
 * }} props
 */
export default function OrderSerialSearchSection({
    orderNumber = '',
    orderSearchLoading = false,
    orderSearchResult = [],
    orderSearchError = '',
    orderNumberSearchSectionRef,
    validationErrors = {},
    onFormChange,
    onSearchClick,
    onOrderSearchShowModalClick,
}) {
    return (
        <>
            <div ref={orderNumberSearchSectionRef}>
                <Form.Group
                    inline
                    style={{
                        alignItems: 'flex-end',
                        flexWrap: 'wrap',
                        gap: '0.75rem',
                    }}
                >
                    <Form.Input
                        label="Sales Order Number (SO#)"
                        name="orderNumber"
                        placeholder="Enter Sales Order Number (SO#)"
                        value={orderNumber}
                        onChange={onFormChange}
                        error={!!validationErrors.orderNumber}
                        width={6}
                    />
                    <Form.Field style={{ marginBottom: 0 }}>
                        <label
                            aria-hidden="true"
                            style={{
                                visibility: 'hidden',
                                display: 'block',
                            }}
                        >
                            Sales Order Number (SO#)
                        </label>
                        <Button
                            content="Search"
                            color="blue"
                            onClick={onSearchClick}
                            loading={!!orderSearchLoading}
                            disabled={!!orderSearchLoading}
                        />
                    </Form.Field>
                    {orderSearchResult.length > 0 && (
                        <Form.Field style={{ marginBottom: 0 }}>
                            <label
                                aria-hidden="true"
                                style={{
                                    visibility: 'hidden',
                                    display: 'block',
                                }}
                            >
                                Sales Order Number (SO#)
                            </label>
                            <Button
                                content="View / Change selection"
                                onClick={onOrderSearchShowModalClick}
                            />
                        </Form.Field>
                    )}
                </Form.Group>
                {validationErrors.orderNumber || orderSearchError ? (
                    <p
                        style={{
                            color: '#9f3a38',
                            fontSize: '0.92em',
                            marginTop: 8,
                            maxWidth: 560,
                        }}
                    >
                        {validationErrors.orderNumber || orderSearchError}
                    </p>
                ) : null}
            </div>
            <p
                style={{
                    color: 'rgba(0,0,0,0.65)',
                    fontSize: '0.9em',
                    marginTop: 8,
                    maxWidth: 720,
                }}
            >
                Search loads repeaters from the sales order. Use Repeater
                Operations below for exchange or remove quantities.
            </p>
        </>
    );
}
